"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formMount = formMount;
var _utils = require("../../utils");
function formMount(formElement, eventHandler) {
  formElement.setAttribute('novalidate', true);
  (0, _utils.addOrRemoveFormEvents)(formElement, 'add', eventHandler);
  return {
    payload: {
      eventHandler,
      formElement
    },
    type: 'formMount'
  };
}